/**
 * 严选采购端接口（`/yanxuan/buyer/*`）允许的角色。
 * 与后端 `yanxuan-buyer-cart.controller.ts` / `yanxuan-buyer-order.controller.ts` 的
 * `@Roles(BUYER, CENTRAL_PURCHASER, COMPANY_ADMIN)` 保持一致；
 * 其它角色（库管 warehouse、requester 等）请求会被 403，且 `api.ts` 会全局弹「没有权限访问该资源」，
 * 因此前端需先按角色门控，不发请求。
 */
export const YANXUAN_BUYER_API_ROLES = ['buyer', 'central_purchaser', 'company_admin'] as const;

export function canCallYanxuanBuyerApi(role?: string | null): boolean {
  if (!role) return false;
  return (YANXUAN_BUYER_API_ROLES as readonly string[]).includes(role);
}

/**
 * 订单明细商品弹窗用目录：采购角色走采购目录；运营/供应商走平台只读目录。
 * 不要先打采购接口再 fallback，否则非采购角色会 403，全局弹出「没有权限」并触发鉴权刷新。
 */
export function yanxuanOrderItemCatalogPath(role: string | null | undefined, productId: number): string {
  const id = Number(productId);
  if (canCallYanxuanBuyerApi(role)) return `/yanxuan/buyer/catalog/${id}`;
  return `/yanxuan/platform/catalog/${id}`;
}
